<template>
  <div class="v2-notice-wrapper d-flex align-items-center mr-2">
    <!-- Nút kích hoạt trên Header -->
    <button
      type="button"
      class="btn-v2-beta"
      @click="openModal"
      title="Khám phá Edutalk Version 2.0"
    >
      <span class="v2-shine"></span>
      <span class="v2-icon-wrap">
        <i class="fal fa-desktop"></i>
      </span>
      <span class="v2-text">
        <strong>Trải nghiệm v2.0</strong>
      </span>
      <span class="v2-badge">BETA</span>
    </button>

    <!-- Dialog giới thiệu & mời tham gia trải nghiệm V2 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="520px"
      custom-class="v2-dialog-custom"
      :append-to-body="true"
      :show-close="true"
      top="12vh"
    >
      <div class="v2-modal-content">
        <!-- Header banner -->
        <div class="v2-hero-banner text-center">
          <div class="v2-hero-icon">
            <i class="fal fa-desktop"></i>
          </div>
          <div class="v2-tag">PHIÊN BẢN MỚI 2.0</div>
          <h3 class="v2-hero-title">Edutalk Version 2.0</h3>
          <p class="v2-hero-desc">
            Hệ thống nội bộ phiên bản 2.0 đã hoàn thiện giai đoạn thử nghiệm.
            Kính mời bạn tham gia trải nghiệm sớm và đóng góp ý kiến cải tiến.
          </p>
        </div>

        <!-- Các tính năng nổi bật -->
        <div class="v2-features-grid">
          <div class="v2-feature-card">
            <div class="feature-icon bg-blue-subtle">
              <i class="fal fa-tachometer-alt"></i>
            </div>
            <div class="feature-info">
              <h4>Tối ưu hiệu năng</h4>
              <p>Tốc độ tải trang nhanh hơn, xử lý dữ liệu mượt mà và ổn định.</p>
            </div>
          </div>

          <div class="v2-feature-card">
            <div class="feature-icon bg-purple-subtle">
              <i class="fal fa-columns"></i>
            </div>
            <div class="feature-info">
              <h4>Giao diện làm việc mới</h4>
              <p>Bố cục hiện đại, trực quan, hỗ trợ thao tác nhanh chóng.</p>
            </div>
          </div>

          <div class="v2-feature-card">
            <div class="feature-icon bg-green-subtle">
              <i class="fal fa-layer-group"></i>
            </div>
            <div class="feature-info">
              <h4>Cải tiến nghiệp vụ & tính năng</h4>
              <p>Nâng cấp các luồng công việc giúp quản lý thuận tiện và chính xác hơn.</p>
            </div>
          </div>
        </div>

        <!-- Hành động -->
        <div class="v2-actions text-center mt-4">
          <button class="btn-try-v2" @click="goToV2">
            <span>Truy cập phiên bản 2.0</span>
            <i class="fal fa-arrow-right ml-2"></i>
          </button>
          <div class="mt-2">
            <button type="button" class="btn-later" @click="dialogVisible = false">
              Để sau
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Version2Notice",
  data() {
    return {
      dialogVisible: false,
      // URL của phiên bản v2
      v2Url: process.env.VUE_APP_BASE_URL_V2 || "https://noibo2.edutalk.edu.vn"
    };
  },
  methods: {
    openModal() {
      this.dialogVisible = true;
    },
    goToV2() {
      this.dialogVisible = false;
      if (this.v2Url) {
        window.open(this.v2Url, "_blank");
      }
    }
  }
};
</script>

<style lang="scss">
/* Style cho dialog khi được append to body */
.v2-dialog-custom {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.16) !important;
  border: none !important;

  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 14px;
      right: 14px;
      z-index: 10;
      .el-dialog__close {
        color: #94a3b8;
        font-size: 16px;
        font-weight: bold;
        transition: all 0.2s;
        &:hover {
          color: #334155;
        }
      }
    }
  }

  .el-dialog__body {
    padding: 24px 28px 24px;
    background: #ffffff;
  }
}
</style>

<style lang="scss" scoped>
.v2-notice-wrapper {
  position: relative;
  user-select: none;
}

/* Nút bấm trên Header */
.btn-v2-beta {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: #ffffff !important;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(79, 70, 229, 0.3);
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 14px rgba(79, 70, 229, 0.45);
    background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);
  }

  &:active {
    transform: translateY(0);
  }

  .v2-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    opacity: 0.9;
  }

  .v2-text {
    letter-spacing: 0.1px;
    white-space: nowrap;
  }

  .v2-badge {
    background: rgba(255, 255, 255, 0.2);
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  /* Hiệu ứng vệt sáng lướt qua nhẹ nhàng */
  .v2-shine {
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.25) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: skewX(-20deg);
    animation: shine-animation 4s infinite;
  }
}

@keyframes shine-animation {
  0% {
    left: -100%;
  }
  20%, 100% {
    left: 200%;
  }
}

/* Modal Content Styling */
.v2-modal-content {
  color: #333;
}

.v2-hero-banner {
  margin-bottom: 20px;

  .v2-hero-icon {
    width: 44px;
    height: 44px;
    margin: 0 auto 10px;
    background: #eef2ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4f46e5;
    font-size: 20px;
  }

  .v2-tag {
    display: inline-block;
    padding: 2px 10px;
    background: #f1f5f9;
    color: #475569;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
  }

  .v2-hero-title {
    font-size: 19px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 6px 0;
  }

  .v2-hero-desc {
    font-size: 13.5px;
    color: #64748b;
    line-height: 1.5;
    margin: 0;
  }
}

.v2-features-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.v2-feature-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  .feature-icon {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;

    &.bg-blue-subtle {
      background: #e0f2fe;
      color: #0284c7;
    }
    &.bg-purple-subtle {
      background: #ede9fe;
      color: #6366f1;
    }
    &.bg-green-subtle {
      background: #dcfce7;
      color: #16a34a;
    }
  }

  .feature-info {
    h4 {
      font-size: 13.5px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 2px 0;
    }
    p {
      font-size: 12.5px;
      color: #64748b;
      margin: 0;
      line-height: 1.35;
    }
  }
}

.v2-actions {
  .btn-try-v2 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 10px 20px;
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 3px 10px rgba(79, 70, 229, 0.35);
    transition: all 0.2s;

    &:hover {
      background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%);
      box-shadow: 0 5px 14px rgba(79, 70, 229, 0.45);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .btn-later {
    background: transparent;
    border: none;
    color: #94a3b8;
    font-size: 12.5px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
    transition: color 0.2s;

    &:hover {
      color: #64748b;
      text-decoration: underline;
    }
  }
}

@media (max-width: 576px) {
  .btn-v2-beta {
    padding: 5px 8px;
    .v2-text {
      display: none;
    }
  }
}
</style>
